import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'ard-general-picture-entity-dialog',
    templateUrl: './general-picture-entity-dialog.component.html'
})

export class GeneralPictureEntityDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<GeneralPictureEntityDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() { }

    kapat() {
        this.dialogRef.close();
    }
}